/**
 * Specifies spreadsheet internal events
 */
/** @hidden */
export const ribbon = 'ribbon';
/** @hidden */
export const formulaBar = 'formulaBar';
/** @hidden */
export const sheetTabs = 'sheetTabs';
/** @hidden */
export const refreshSheetTabs = 'refreshSheetTabs';
/** @hidden */
export const isFormulaBarEdit = 'isFormulaBarEdit';
/** @hidden */
export const contentLoaded = 'contentLoaded';
/** @hidden */
export const mouseDown = 'mouseDown';
/** @hidden */
export const spreadsheetDestroyed = 'spreadsheetDestroyed';
/** @hidden */
export const editOperation = 'editOperation';
/** @hidden */
export const formulaOperation = 'formulaOperation';
/** @hidden */
export const formulaBarOperation = 'formulaBarOperation';
/** @hidden */
export const click = 'click';
/** @hidden */
export const keyUp = 'keyUp';
/** @hidden */
export const keyDown = 'keyDown';
/** @hidden */
export const formulaKeyUp = 'formulaKeyUp';
/** @hidden */
export const formulaBarUpdate = 'formulaBarUpdate';
/** @hidden */
export const onVerticalScroll = 'verticalScroll';
/** @hidden */
export const onHorizontalScroll = 'horizontalScroll';
/** @hidden */
export const focusRenameInput = 'focusRenameInput';
/** @hidden */
export const beforeContentLoaded = 'beforeContentLoaded';
/** @hidden */
export const beforeVirtualContentLoaded = 'beforeVirtualContentLoaded';
/** @hidden */
export const virtualContentLoaded = 'virtualContentLoaded';
/** @hidden */
export const contextMenuOpen = 'contextMenuOpen';
/** @hidden */
export const cellNavigate = 'cellNavigate';
/** @hidden */
export const mouseUpAfterSelection = 'mouseUpAfterSelection';
/** @hidden */
export const cMenuBeforeOpen = 'contextmenuBeforeOpen';
/** @hidden */
export const insertSheetTab = 'insertSheetTab';
/** @hidden */
export const removeSheetTab = 'removeSheetTab';
/** @hidden */
export const renameSheetTab = 'renameSheetTab';
/** @hidden */
export const ribbonClick = 'ribboClick';
/** @hidden */
export const refreshRibbon = 'ribbonRefresh';
/** @hidden */
export const enableToolbarItems = 'enableToolbarItems';
/** @hidden */
export const tabSwitch = 'tabSwitch';
/** @hidden */
export const selectRange = 'selectRange';
/** @hidden */
export const rangeSelectionByKeydown = 'rangeSelectionByKeydown';
/** @hidden */
export const cut = 'cut';
/** @hidden */
export const copy = 'copy';
/** @hidden */
export const paste = 'paste';
/** @hidden */
export const clearCopy = 'clearCopy';
/** @hidden */
export const dataBound = 'dataBound';
/** @hidden */
export const beforeDataBound = 'beforeDataBound';
/** @hidden */
export const addContextMenuItems = 'addContextMenuItems';
/** @hidden */
export const removeContextMenuItems = 'removeContextMenuItems';
/** @hidden */
export const enableContextMenuItems = 'enableContextMenuItems';
/** @hidden */
export const enableFileMenuItems = 'enableFileMenuItems';
/** @hidden */
export const hideFileMenuItems = 'hideFileMenuItems';
/** @hidden */
export const addFileMenuItems = 'addFileMenuItems';
/** @hidden */
export const hideRibbonTabs = 'hideRibbonTabs';
/** @hidden */
export const enableRibbonTabs = 'enableRibbonTabs';
/** @hidden */
export const addRibbonTabs = 'addRibbonTabs';
/** @hidden */
export const addToolbarItems = 'addToolbarItems';
/** @hidden */
export const hideToolbarItems = 'hideToolbarItems';
/** @hidden */
export const beforeRibbonCreate = 'beforeRibbonCreate';
/** @hidden */
export const rowHeightChanged = 'rowHeightChanged';
/** @hidden */
export const colWidthChanged = 'colWidthChanged';
/** @hidden */
export const onContentScroll = 'onContentScroll';
/** @hidden */
export const deInitProperties = 'deInitProperties';
/** @hidden */
export const activeSheetChanged = 'activeSheetChanged';
/** @hidden */
export const initiateCustomSort = 'initiateCustomSort';
/** @hidden */
export const applySort = 'applySort';
/** @hidden */
export const collaborativeUpdate = 'collaborativeUpdate';
/** @hidden */
export const autoFit = 'autoFitRowsColumns';
/** @hidden */
export const refreshFilterCellsOnResize = 'refreshFilterCellsOnResize';
/** @hidden */
export const updateToggleItem = 'updateToggleItem';
/** @hidden */
export const initiateHyperlink = 'initiateHyperlink';
/** @hidden */
export const editHyperlink = 'editHyperlink';
/** @hidden */
export const openHyperlink = 'openHyperlink';
/** @hidden */
export const addNote = 'addNote';
/** @hidden */
export const editNote = 'editNote';
/** @hidden */
export const deleteNote = 'deleteNote';
/** @hidden */
export const showNote = 'showNote';
/** @hidden */
export const showHideNote = 'showHideNote';
/** @hidden */
export const navigateNextPrevNote = 'navigateNextPrevNote';
/** @hidden */
export const showAllNotes = 'showAllNotes';
/** @hidden */
export const processSheetNotes = 'processSheetNotes';
/** @hidden */
export const noteUndoRedo = 'noteUndoRedo';
/** @hidden */
export const createNoteIndicator = 'createNoteIndicator';
/** @hidden */
export const updateNoteContainer = 'updateNoteContainer';
/** @hidden */
export const removeNoteContainer = 'removeNoteContainer';
/** @hidden */
export const initiateComment = 'initiateComment';
/** @hidden */
export const replyToComment = 'replyToComment';
/** @hidden */
export const showCommentsPane = 'showCommentsPane';
/** @hidden */
export const navigateNextPrevComment = 'navigateNextPrevComment';
/** @hidden */
export const refreshCommentsPane = 'refreshCommentsPane ';
/** @hidden */
export const deleteComment = 'deleteComment';
/** @hidden */
export const createCommentIndicator = 'createCommentIndicator';
/** @hidden */
export const removeCommentContainer = 'removeCommentContainer';
/** @hidden */
export const processSheetComments = 'processSheetComments';
/** @hidden */
export const commentUndoRedo = 'commentUndoRedo';
/** @hidden */
export const removeHyperlink = 'removeHyperlink';
/** @hidden */
export const createHyperlinkElement = 'createHyperlinkElement';
/** @hidden */
export const sheetNameUpdate = 'sheetNameUpdate';
/** @hidden */
export const hideSheet = 'hideSheet';
/** @hidden */
export const performUndoRedo = 'performUndoRedo';
/** @hidden */
export const updateUndoRedoCollection = 'updateUndoRedoCollection';
/** @hidden */
export const setActionData = 'setActionData';
/** @hidden */
export const getBeforeActionData = 'getBeforeActionData';
/** @hidden */
export const clearUndoRedoCollection = 'clearUndoRedoCollection';
/** @hidden */
export const initiateFilterUI = 'initiateFilterUI';
/** @hidden */
export const renderFilterCell = 'renderFilterCell';
/** @hidden */
export const refreshFilterRange = 'refreshFilterRange';
/** @hidden */
export const reapplyFilter = 'reapplyFilter';
/** @hidden */
export const filterByCellValue = 'filterByCellValue';
/** @hidden */
export const clearFilter = 'clearFilter';
/** @hidden */
export const getFilteredColumn = 'getFilteredColumn';
/** @hidden */
export const completeAction = 'actionComplete';
/** @hidden */
export const filterCellKeyDown = 'filterCellKeyDown';
/** @hidden */
export const getFilterRange = 'getFilterRange';
/** @hidden */
export const setAutoFit = 'setAutoFit';
/** @hidden */
export const refreshFormulaDatasource = 'refreshFormulaDatasource';
/** @hidden */
export const initiateDataValidation = 'initiatedatavalidation';
/** @hidden */
export const validationError = 'validationError';
/** @hidden */
export const startEdit = 'startEdit';
/** @hidden */
export const invalidData = 'invalidData';
/** @hidden */
export const clearInvalid = 'clearInvalid';
/** @hidden */
export const protectSheet = 'protectSheet';
/** @hidden */
export const applyProtect = 'applyProtect';
/** @hidden */
export const unprotectSheet = 'unprotectSheet';
/** @hidden */
export const protectCellFormat = 'protectCellFormat';
/** @hidden */
export const gotoDlg = 'renderGotoDlgt';
/** @hidden */
export const findDlg = 'renderFindDlg';
/** @hidden */
export const findHandler = 'findHandler';
/** @hidden */
export const created = 'created';
/** @hidden */
export const spreadsheetCreated = 'spreadsheetCreated';
/** @hidden */
export const editAlert = 'editAlert';
/** @hidden */
export const readonlyAlert = 'readonlyAlert';
/** @hidden */
export const finiteAlert = 'finiteAlert';
/** @hidden */
export const setUndoRedo = 'setUndoRedo';
/** @hidden */
export const enableFormulaInput = 'enableFormulaInput';
/** @hidden */
export const protectSelection = 'protectSelection';
/** @hidden */
export const hiddenMerge = 'hiddenMerge';
/** @hidden */
export const checkPrevMerge = 'checkPrevMerge';
/** @hidden */
export const checkMerge = 'checkMerge';
/** @hidden */
export const removeDataValidation = 'removeDataValidation';
/** @hidden */
export const showAggregate = 'showAggregate';
/** @hidden */
export const goToSheet = 'goToSheet';
/** @hidden */
export const showSheet = 'showSheet';
/** @hidden */
export const renderCFDlg = 'renderCFDlg';
/** @hidden */
export const clearViewer = 'clearViewer';
/** @hidden */
export const initiateFormulaReference = 'initiateFormulaReference';
/** @hidden */
export const initiateCur = 'initiateCur';
/** @hidden */
export const clearCellRef = 'clearCellRef';
/** @hidden */
export const editValue = 'editValue';
/** @hidden */
export const addressHandle = 'addressHandle';
/** @hidden */
export const initiateEdit = 'initiateEdit';
/** @hidden */
export const forRefSelRender = 'forRefSelRender';
/** @hidden */
export const insertImage = 'insertImage';
/** @hidden */
export const refreshOverlayElem = 'refreshOverlayElem';
/** @hidden */
export const refreshImgCellObj = 'refreshImgCellObj';
/** @hidden */
export const getRowIdxFromClientY = 'getRowIdxFromClientY';
/** @hidden */
export const getColIdxFromClientX = 'getColIdxFromClientX';
/** @hidden */
export const createImageElement = 'createImageElement';
/** @hidden */
export const deleteImage = 'deleteImage';
/** @hidden */
export const deleteChart = 'deleteChart';
/** @hidden */
export const refreshChartCellObj = 'refreshChartCellObj';
/** @hidden */
export const refreshChartCellModel = 'refreshChartCellModel';
/** @hidden */
export const refreshImagePosition = 'refreshImagePosition';
/** @hidden */
export const updateTableWidth = 'updateTableWidth';
/** @hidden */
export const focusBorder = 'focusBorder';
/** @hidden */
export const clearChartBorder = 'clearChartBorder';
/** @hidden */
export const insertChart = 'insertChart';
/** @hidden */
export const chartRangeSelection = 'chartRangeSelection';
/** @hidden */
export const insertDesignChart = 'insertDesignChart';
/** @hidden */
export const removeDesignChart = 'removeDesignChart';
/** @hidden */
export const chartDesignTab = 'chartDesignTab';
/** @hidden */
export const undoRedoForChartDesign = 'undoRedoForChartDesign';
/** @hidden */
export const protectWorkbook = 'protectWorkbook';
/** @hidden */
export const unProtectWorkbook = 'unProtectWorkbook';
/** @hidden */
export const setProtectWorkbook = 'setProtectWorkbook';
/** @hidden */
export const removeWorkbookProtection = 'removeWorkbookProtection';
/** @hidden */
export const importProtectWorkbook = 'importProtectWorkbook';
/** @hidden */
export const selectionStatus = 'selectionStatus';
/** @hidden */
export const freeze = 'freeze';
/** @hidden */
export const overlayEleSize = 'overlayEleSize';
/** @hidden */
export const updateScroll = 'updateScroll';
/** @hidden */
export const positionAutoFillElement = 'positionAutoFillElement';
/** @hidden */
export const hideAutoFillOptions = 'hideAutoFillOptions';
/** @hidden */
export const performAutoFill = 'performAutoFill';
/** @hidden */
export const selectAutoFillRange = 'selectAutoFillRange';
/** @hidden */
export const autoFill = 'autoFill';
/** @hidden */
export const hideAutoFillElement = 'hideAutoFillElement';
/** @hidden */
export const unProtectSheetPassword = 'unProtectSheetPassword';
/** @hidden */
export const updateTranslate = 'updateTranslate';
/** @hidden */
export const getUpdatedScrollPosition = 'getUpdatedScrollPosition';
/** @hidden */
export const updateScrollValue = 'updateScrollValue';
/** @hidden */
export const beforeCheckboxRender = 'beforeCheckboxfilterRenderer';
/** @hidden */
export const refreshCheckbox = 'refreshCheckbox';
/** @hidden */
export const renderInsertDlg = 'renderInsertDlg';
/** @hidden */
export const toggleProtect = 'toggleProtect';
/** @hidden */
export const propertyChange = 'propertyChange';
/** @hidden */
export const updateWrapCell = 'updateWrapCell';
